import type { ComponentType } from "react";
import type { Task } from "@common/types/task";
import type { DataGridCellProps } from "@design-system/DataGrid";
import type { NestedTaskRow } from "../../types";

export type TaskListCell = ComponentType<DataGridCellProps<NestedTaskRow>>;

/** A task row or a draft (placeholder) row: every task field is set. */
export type TaskListTaskRow = NestedTaskRow & Task;

/** Whether a row is a task or a draft task rather than a group. */
export const hasTaskFields = (row: NestedTaskRow): row is TaskListTaskRow =>
    !row.isGroup && row.workspaceId !== undefined;

/** A read-only column's cell: `TaskValue` on task rows, nothing on group and draft rows. */
export const toReadOnlyTaskCell = (
    TaskValue: ComponentType<{ task: TaskListTaskRow }>,
): TaskListCell => {
    const ReadOnlyTaskCell = ({
        context,
    }: DataGridCellProps<NestedTaskRow>) => {
        const task = context.row.original;
        return hasTaskFields(task) && !task.isNewPlaceholder ? (
            <TaskValue task={task} />
        ) : null;
    };
    return ReadOnlyTaskCell;
};
